import { render, staticRenderFns } from "./TotemJourneysTable.vue?vue&type=template&id=749dbb17"
import script from "./TotemJourneysTable.vue?vue&type=script&lang=js"
export * from "./TotemJourneysTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports